import React, { Component } from 'react'
import SessionHelper from '../../contextHelper/SessionHelper'
import LogoutPageUI from './LogoutPageUI.js'
import RestApiUtils from '../../apiclient/moebli/RestApiUtils'
import LocalStorageKeys from '../../cache/LocalStorageKeys'

class LogoutPageSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      successMsg: null,
    }
  }

  render() {
    return (
      <LogoutPageUI
        context={this.props.context}
        successMsg={this.state.successMsg}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
    this.deleteSession(context)
  }

  deleteSession(context) {
    if (context.session.impersonated) {
      RestApiUtils.put(this.props.context,
        '/api/su/accounts/current/unimpersonate',
        this.unimpersonateCallback
      )
    }
    else {
      RestApiUtils.delete(this.props.context,
        '/api/pub/session',
        this.deleteSessionCallback
      )
    }
  }

  unimpersonateCallback = (response) => {
    let context = this.props.context
    context.session = response.session
    context.permissions = response.permissionList

    this.setState({
      context: context,
      successMsg: response.success
    })

    localStorage.setItem(LocalStorageKeys.Session, JSON.stringify(response.session))
    localStorage.setItem(LocalStorageKeys.Session + ':CachedTime', Date.now()/1000)

    setTimeout(() => {
       window.location.href = '/su/accounts'
    }, 1000);
  }

  deleteSessionCallback = (response) => {
    let context = this.props.context
    sessionStorage.clear()
    localStorage.clear()
    context.session = null
    // calling onContextChange causes infinite loop as componentDidMount
    // invoked again
    // context.onContextChange(context)

    this.setState({successMsg: response.success})
    let sessionHelper = new SessionHelper(context)
    sessionHelper.getSession()

    setTimeout(() => {
       window.location = '/'
    }, 2000);
  }
}

export default LogoutPageSF
